import { makeObservable, observable, computed, action, toJS } from 'mobx';
import Event from './Event';

export default class Events {
    is_loading = true;
    events = [];
    selected_event;
    participant_group_by = 'status';
    participant_group_by_options = [
        { key: 'status', name: 'Status (Default)' },
        { key: 'school_name', name: 'School Name' },
        { key: 'registration_type', name: 'Registration Type' }
    ];
    has_focus = true;
    filter = '';

    constructor({ guid, csrf }) {
        makeObservable(this, {
            is_loading: observable,
            events: observable,
            selected_event: observable,
            participant_group_by: observable,
            has_focus: observable,
            filter: observable,
            guids: computed,
            events_filtered: computed,
            current_event: computed,
            getData: action.bound
        });

        this.csrf = csrf;
        this.events = observable(guid.map(e => new Event(e, this)));
        this.getData();
        this._interval = setInterval(() => this.getDataInterval(), 5000);

        window.onfocus = window.onblur = window.onpageshow = window.onpagehide = e => {
            if (e.type === 'focus') this.has_focus = true;
            if (e.type === 'blur') this.has_focus = false;
        }
    }

    get guids() {
        return this.events.map(e => e.guid);
    }

    get events_filtered() {
        if (!this.filter) {
            return this.events;
        }

        return this.events.filter(e => e.participants_filtered.length);
    }

    get events_filtered_sorted() {
        const events = this.events_filtered;
        return events.slice().sort((a, b) => {
            return a.title > b.title ? 1 : (a.title < b.title ? -1 : 0);
        });
    }

    get current_event() {
        if (this.selected_event) {
            const event = this.events_filtered.find(e => e === this.selected_event);

            if (event) {
                return event;
            }
        }

        return this.events_filtered[0];
    }

    getDataInterval() {
        if (this.has_focus) {
            this.getData();
        }
    }

    getData() {
        $.ajax({
            method: 'post',
            url: `/workshops/attendance/lookup/`,
            data: { csrfmiddlewaretoken: this.csrf, guid: this.guids.join(',') }
        }).then(data => {
            try {
                data = JSON.parse(data);
            } catch (e) {
                return;
            }

            this.is_loading = false;

            for (const event of data.events) {
                const storedEvent = this.events.find(e => e.guid === event.guid);
                if (storedEvent) {
                    storedEvent.fillData(event);
                }
            }
        });
    }
}